import { render } from "./App.vue?vue&type=template&id=91ee212c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=91ee212c&lang=css"

import exportComponent from "/home/ubuntu/Monitoring/WebInterface/cobox-monitoringv2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__